export const createDiscountCodesRequests = (client) => ({
    listDiscountCodes: async (params) => {
        const { data, meta, links } = await client.api.get("discount_codes", {
            params: params,
        });
        return { data, meta, links };
    },
    createDiscountCode: async (payload) => {
        const { data } = await client.api.create("discount_code", payload);
        return { data };
    },
    deleteDiscountCode: async (id) => {
        return client.api.remove("discount_codes", id);
    },
    validateDiscountCode: async (payload) => {
        const { data } = await client.api.request({
            type: "discount_codes",
            url: "/discount_codes/validate",
            method: "POST",
            body: payload,
        });
        return { data };
    },
});
//# sourceMappingURL=index.js.map